import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { userStamp } from '../../../../utils/dateFunctions';
import getMediaType, { isImageFile, isVideoFile } from '../../../../utils/mediaTypes';
import AttachmentVideo from '../../../../components/AttachmentVideo';
import {
	selectedWorkItemValue,
	workItemSelectOptions,
	workItemCategoryColor,
} from './fileAttachmentWorkItems';
import AttachToWorkItemDialog from './AttachToWorkItemDialog';

class FileAttachmentOverlay extends PureComponent {
	constructor(props) {
		super(props);
		this.state = { attachOpen: false };
		this.onBackdrop = this.onBackdrop.bind(this);
		this.downloadFile = this.downloadFile.bind(this);
	}

	onBackdrop(e) {
		if (e.target === e.currentTarget) {
			this.props.onClose();
		}
	}

	async downloadFile() {
		const { attachment } = this.props;
		const response = await fetch(attachment.location);
		const blob = await response.blob();
		const downloadBlob = new Blob([blob], { type: getMediaType(attachment.fileid) });
		const data = window.URL.createObjectURL(downloadBlob);
		const link = document.createElement('a');
		link.href = data;
		link.setAttribute('download', (attachment.fileid || 'file').split('.').shift());
		document.body.appendChild(link);
		link.click();
		setTimeout(() => {
			document.body.removeChild(link);
			window.URL.revokeObjectURL(data);
		}, 100);
	}

	workItemMatch() {
		const { attachment } = this.props;
		const value = selectedWorkItemValue(attachment);
		if (!value) return null;
		const vehicle = this.props.active_vehicle || {};
		const options = workItemSelectOptions({
			mpiWorkItems: [vehicle.mpi_work_items, this.props.mpi_work_items],
			appraisals: [vehicle.appraisals, this.props.appraisals],
			workItems: [vehicle.work_items, this.props.work_items],
			vehicleId: this.props.vehicle_id,
		});
		return options.find(opt => opt.value === value) || { value, label: 'Attached work item', category: '' };
	}

	renderMedia() {
		const { attachment } = this.props;
		if (isImageFile(attachment.fileid)) {
			return <img src={attachment.location} alt={attachment.fileid || ''} />;
		}
		if (isVideoFile(attachment.fileid)) {
			return <AttachmentVideo src={attachment.location} filename={attachment.fileid} />;
		}
		return (
			<div className="text-center text-muted p-4">
				<p className="mb-2">Preview not available for this file type.</p>
				<p className="mb-0 fw-semibold">{attachment.fileid}</p>
			</div>
		);
	}

	renderWorkItemBlock() {
		const match = this.workItemMatch();
		if (match) {
			return (
				<div className="wi-chip">
					<div className="l">
						<span className="dot" style={{ background: workItemCategoryColor(match.category) }} />
						<span className="name">{match.label}</span>
					</div>
					<button type="button" className="link-btn" onClick={() => this.setState({ attachOpen: true })}>
						Change
					</button>
				</div>
			);
		}
		return (
			<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
				<div className="empty-wi">Not linked yet.</div>
				<button
					type="button"
					className="btn-fv btn-fv-primary"
					onClick={() => this.setState({ attachOpen: true })}
				>
					+ Select Work Item
				</button>
			</div>
		);
	}

	render() {
		const { attachment } = this.props;
		const createdDate = userStamp(attachment.created_at);
		const uploader = attachment.user_name
			? attachment.user_name.split('@')[0]
			: null;

		return (
			<div className="files-overlay-backdrop" onClick={this.onBackdrop} role="presentation">
				<div
					className="files-overlay-panel"
					role="dialog"
					aria-modal="true"
					aria-label="File details"
					onClick={e => e.stopPropagation()}
				>
					<div className="panel-head">
						<div className="h">File details</div>
						<button
							type="button"
							className="icon-btn"
							aria-label="Close"
							onClick={this.props.onClose}
						>
							<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
								<line x1="4" y1="4" x2="20" y2="20" />
								<line x1="20" y1="4" x2="4" y2="20" />
							</svg>
						</button>
					</div>

					<div className="panel-body">
						<div className="panel-preview">{this.renderMedia()}</div>
						<div className="panel-info-row">
							<div>
								<div className="panel-fname">{attachment.fileid}</div>
								<div className="panel-meta">
									Uploaded
									{uploader ? ` by ${uploader}` : ''}
									{` on ${createdDate}`}
								</div>
							</div>
							<div className="panel-wi">
								<div className="section-label">Work item</div>
								{this.renderWorkItemBlock()}
							</div>
						</div>
					</div>

					<div className="panel-actions">
						<button type="button" className="btn-fv btn-fv-teal btn-fv-block" onClick={this.downloadFile}>
							Download
						</button>
						<button
							type="button"
							className="btn-fv btn-fv-red btn-fv-block"
							onClick={() => this.props.onDelete(attachment.id)}
						>
							Delete
						</button>
					</div>

					{this.state.attachOpen && (
						<AttachToWorkItemDialog
							attachment={attachment}
							vehicle_id={this.props.vehicle_id}
							onClose={() => this.setState({ attachOpen: false })}
							onAttached={() => this.setState({ attachOpen: false })}
						/>
					)}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		active_vehicle: state.settings_refresh.active_vehicle,
		mpi_work_items: state.settings_refresh.mpi_work_items,
		appraisals: state.settings_refresh.appraisals,
		work_items: state.settings_refresh.work_items,
	};
}

export default connect(mapStateToProps)(FileAttachmentOverlay);
